import router from '@/router';
import api from './api';

const relatorioJogadorServices = {
  // Lista todas as dados-jogador-partida
  findAll() {
    return api
      .get('/dados-jogador-partida')
      .then((response) => response.data)
      .catch((error) => {
        if (error.response && error.response.status === 403) {
          router.push('/login');
        }
        console.error('Erro ao listar dados-jogador-partida:', error);
        throw error;
      });
  },
  findById(id, idPartida) {
    return api
      .get(`${'/dados-jogador-partida'}/${id}/${idPartida}`)
      .then((response) => response.data)
      .catch((error) => {
        console.error(`Erro ao buscar partida com ID ${id}:`, error);
        throw error;
      });
  },
  findMidiasById(id, idPartida) {
    return api
      .get(`${'/dados-jogador-partida'}/${id}/${idPartida}/midias`)
      .then((response) => response.data)
      .catch((error) => {
        console.error(`Erro ao buscar partida com ID ${id}:`, error);
        throw error;
      });
  },
  save(partida) {
    return api
      .post('/dados-jogador-partida', partida)
      .then((response) => response.data)
      .catch((error) => {
        console.error('Erro ao criar partida:', error);
        throw error;
      });
  },
  update(id, partida) {
    return api
      .put(`${'/dados-jogador-partida'}/${id}`, partida)
      .then((response) => response.data)
      .catch((error) => {
        console.error(`Erro ao atualizar partida com ID ${id}:`, error);
        throw error;
      });
  },
  deleteById(id) {
    return api
      .delete(`${'/dados-jogador-partida'}/${id}`)
      .then((response) => response.data)
      .catch((error) => {
        console.error(`Erro ao deletar partida com ID ${id}:`, error);
        throw error;
      });
  },
};
export default relatorioJogadorServices;
